import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";

export const Label = styled(Typography)(
    ({theme}) => `
                margin-bottom: 10px !important;
                margin-top: 10px;
              `);